import * as React from 'react';
import FileService from '@lifeomic/phc-web-toolkit/src/services/FileService';
import { AxiosResponse } from 'axios';
import { useServiceAuth } from '@lifeomic/phc-web-toolkit/src/hooks';

const fileService = new FileService();

export const getReadSetFileName = (readSet: any) =>
  readSet?.fileName?.includes('RNA') ? 'RNA' : 'DNA';

export const useFetchReadSetFiles = (test: any, setActiveTest: any) => {
  const auth = useServiceAuth();

  const fetchFiles = React.useCallback(async () => {
    if (!test) {
      return;
    }

    const readSets = test.sets.filter(
      (set: any) => set.setType === 'read' && !set.fileName,
    );

    const responses: AxiosResponse<any>[] = await Promise.all(
      readSets.map((set: any) => fileService.getFile(auth)(set.fileId)),
    );

    responses.forEach(response => {
      if (response.data) {
        const set = test.sets.find(
          (set: any) => set.fileId === response.data.id,
        );
        const fileName = response.data.name;

        if (fileName) {
          set.fileName = fileName;
        }
      }
    });

    setActiveTest(test);
  }, [auth, setActiveTest, test]);

  React.useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);
};
